import { setCookie } from 'cookies-next/client'

import { COOKIE_FROZEN_EXPA_NAME } from '../cookies'

export const expaSetClientSideFrozenExpaCookie = (expa: string): void => {
  if (!expa) {
    return
  }

  setCookie(COOKIE_FROZEN_EXPA_NAME, expa, {
    httpOnly: false,
  })
}
